export const parseSlug = (slug?: string[] | string): string => {
  if (!slug || Object.keys(slug).length === 0 || (slug.length === 1 && (slug[0] === 'fr-fr' || slug[0] === 'en-us'))) {
    return '/';
  }

  return Array.isArray(slug) ? `/${slug.join('/')}` : `/${slug}`;
};
